module.exports = __webpack_public_path__ + "img/album07_12.17b85b26.jpg";